import React from "react";
import { IoMdCall } from "react-icons/io";
import { IoMail } from "react-icons/io5";
import { GrInstagram } from "react-icons/gr";

import "./Footer.css";


function Footer({ setCurrentPage }) {
  const handleLinkClick = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        
        {/* Column 1: Branding & Info */}
        <div className="footer-column branding-col">
          <h3 className="footer-logo-title">Vinayak Agro Chemicals</h3>
          <p className="footer-tagline">
            Your Trusted Partner in High-Yield Farming. Direct distributor of 100% original quality pesticides, hybrid seeds, and fertilizers in Gujarat.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column links-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links-list">
            <li>
              <button onClick={() => handleLinkClick("home")} className="footer-link-btn">
                Home
              </button>
            </li>
            <li>
              <button onClick={() => handleLinkClick("about")} className="footer-link-btn">
                About Us
              </button>
            </li>
            <li>
              <button onClick={() => handleLinkClick("products")} className="footer-link-btn">
                Products
              </button>
            </li>
            <li>
              <button onClick={() => handleLinkClick("awards")} className="footer-link-btn">
                Hall of Fame
              </button>
            </li>
            <li>
              <button onClick={() => handleLinkClick("contact")} className="footer-link-btn">
                Contact Us
              </button>
            </li>
          </ul>
        </div>

        {/* Column 3: Contact Info */}
        <div className="footer-column contact-col">
          <h4 className="footer-heading">Contact Details</h4>
          <ul className="footer-contact-list">
            <li>
              <span className="footer-icon"><IoMdCall /></span>
              <a href="tel:+919773255243" className="footer-contact-link">+91 97732 55243 (Chandu Faldu)</a>
            </li>
            <li>
              <span className="footer-icon"><IoMdCall /></span>
              <a href="tel:+918264191234" className="footer-contact-link">+91 82641 91234 (Jaydip Faldu)</a>
            </li>
            <li>
              <span className="footer-icon"><IoMail /></span>
              <a href="mailto:info@vinayakagrochemicals.com" className="footer-contact-link">info@vinayakagrochemicals.com</a>
            </li>
            <li>
              <span className="footer-icon"><GrInstagram /></span>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-contact-link">@vinayak_agro_chemicals</a>
            </li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().getFullYear()} Vinayak Agro Chemicals. All Rights Reserved.</p>
          <p className="footer-design-credit">Distributors of Pesticides, Hybrid Seeds, & Fertilizers</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
